import script from "./security-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./security-settings.vue?vue&type=script&setup=true&lang=js"

import "./security-settings.vue?vue&type=style&index=0&id=1959a9ae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1959a9ae"]])

export default __exports__